class MapClass {
  getSensorLatLng (sensorType: string, data: any) {
    if (data !== null) {
      let latKye = sensorType + '_lat'
      let lngKye = sensorType + '_lng'
      if (data[latKye] !== null && data[lngKye] !== null) {
        const position = {
          lat: data[latKye],
          lng: data[lngKye]
        }
        return position
      }
    }
    return null
  }
}

export default new MapClass()
